
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/creative",
      function () {
        return require("private-next-pages/context-hub/creative.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/creative"])
      });
    }
  